/* eslint-disable eqeqeq */
import React, { useState } from "react";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatName, getModuleNamingBySlug } from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import MainBody from "../../../components/MainBody/MainBody";
import { Button } from "../../../components/ui/button";
import { CheckCircle2, Clock, LucideMessageSquareShare } from "lucide-react";
import Confirmation from "../../../components/Confirmation";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { PhoneInput } from "../../../components/ui/phone-input";
import { Checkbox } from "../../../components/ui/checkbox";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import EscalatedModal from "./EscalatedModal";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import BiometricsStatus from "./BiometricsStatus";

// * Start: Vendor Listing Page
const ExpandContactTypeCDD = ({ cddsList, fetchCDDs, user = false }) => {
  // * Start: Url Management State

  const [loading, setLoading] = useState(false);

  // * End: Url Management State

  // * Start: List Management State

  const [confirmVerify, setConfirmVerify] = useState(false);
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [mobile, setMobile] = useState();
  const [consent, setConsent] = useState();
  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [confirmEscalated, setConfirmEscalated] = useState(false);
  const { organizationData } = useOrganization();

  // * End: List Management State

  //* End: Fetch Vendor List Form The API

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
      setCddItem();
      setMobile();
      setConsent();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmVerify(!confirmVerify);
  };

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  const handleVerifyID = async () => {
    try {
      setLoading(true);
      await get(
        `${API.GET_CDD_VERFIY}/${cddId}?mobile=${mobile ? mobile : ""}`,
      );
      setLoading(false);
      fetchCDDs();
    } catch (error) {
      setLoading(false);
      fetchCDDs();
    }
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of EnhancedCDDs)
   * @returns {Array} Vendor List
   **/

  const cddsGenerator = (quantity) => {
    const items = [];
    let cddListData = cddsList[0];
    let contactData = cddsList[0]?.vendor_id
      ? cddsList[0]?.vendor
      : cddsList[0]?.contact_id
        ? cddsList[0]?.contact
        : cddsList[0]?.beneficiary_id
          ? cddsList[0]?.beneficiary
          : cddsList[0]?.user_id
            ? cddsList[0]?.user
            : "";

    for (let i = 0; i < quantity; i++) {
      items.push({
        key: cddListData?.id,
        id: cddListData?.id ? cddListData?.id : "",
        cdd: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        cdd_customer_type: cddListData?.cdd_customer_type
          ? cddCustomerTypeOptions?.find(
              (item) => item.value === cddListData?.cdd_customer_type,
            )?.label
          : "-",

        cdd_type: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        risk: (
          <div className="flex items-center gap-2">
            {cddListData?.risk
              ? riskProfile?.find((item) => item.value == cddListData?.risk)
                  ?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(cddListData?.id, cddListData);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: cddListData?.source ? cddListData?.source : "",

        verification_document_type: cddListData?.verifications[i]
          ?.verification_document_type?.label
          ? cddListData?.verifications[i]?.verification_document_type?.label
          : "",
        date_verified: cddListData?.verifications[i]?.date_verified
          ? cddListData?.verifications[i]?.date_verified
          : "",
        verified_by: cddListData?.verifications[i]?.verified_by
          ? formatName(
              cddListData?.verifications[i]?.verified_by?.first_name,
              cddListData?.verifications[i]?.verified_by?.last_name,
            )
          : "",

        biometrics: cddListData?.verifications[i]?.["bdv_results"]?.[
          "bdv_results"
        ] ? (
          <BiometricsStatus
            results={
              cddListData?.verifications[i]?.["bdv_results"]?.["bdv_results"]
            }
          />
        ) : (
          ""
        ),
        method: cddListData?.verifications[i]?.method_title
          ? cddListData?.verifications[i]?.method_title
          : "",
        bureau: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"bureau"}
            fetchData={fetchCDDs}
          />
        ),
        dvs: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"dvs"}
            fetchData={fetchCDDs}
          />
        ),
        pep: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"pep"}
            fetchData={fetchCDDs}
          />
        ),
        sanction: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"sanction"}
            fetchData={fetchCDDs}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              cddListData?.summaries?.length > 0
                ? cddListData?.summaries?.[0]?.adverse_media_result
                : ""
            }
            reference_no={
              cddListData?.summaries?.length > 0
                ? cddListData?.summaries?.[0]?.request_id
                : ""
            }
          />
        ),
        action: (
          <>
            <span className="flex items-center gap-2 justify-center">
              {cddListData?.kyb_report_file ? (
                <KYBReportDownload
                  setLoading={setLoading}
                  kyb_report_file={cddListData?.kyb_report_file}
                />
              ) : (
                <></>
              )}
              {cddListData?.verifications[i]?.verified === 1 ? (
                <Button
                  size={"sm"}
                  className="bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                >
                  <div className="flex items-center gap-1">
                    <CheckCircle2 size={18} />
                    <span>Verified</span>
                  </div>
                </Button>
              ) : cddListData?.verifications[i]?.verified === 2 ? (
                <>
                  <Button
                    size={"sm"}
                    className="bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <Clock size={18} />
                      <span>Pending</span>
                    </div>
                  </Button>
                  <CDDVerifyCheck
                    listData={cddListData}
                    setCddId={setCddId}
                    setLoading={setLoading}
                    cddId={cddId}
                    fecthData={fetchCDDs}
                  />
                </>
              ) : cddListData?.verifications[i]?.method !== 1 ? (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>

                      <span>/</span>
                    </>
                  )}
                  <CDDVerifyModal
                    loading={loading}
                    listData={cddListData}
                    setCddItem={setCddItem}
                    setCddId={setCddId}
                    cddItem={cddItem}
                    customerType={contactData?.type}
                    setLoading={setLoading}
                    cddId={cddId}
                    sectionType={cddListData?.cdd_customer_type}
                    fecthData={fetchCDDs}
                    defaultMobile={contactData?.mobile ? contactData?.mobile : ''}
                    defaultABN={contactData?.abn}
                    cdd={cddListData?.cdd}
                  />
                </>
              ) : (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      <span>/</span>
                    </>
                  )}
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(
                            cddListData?.id,
                            cddListData?.verifications[i],
                          );
                        }}
                      />
                    </span>
                  </CustomTooltip>
                </>
              )}
            </span>
          </>
        ),
      });
    }

    if (contactData?.type == 2 && contactData?.entity_type === "1") {
      items.push({
        key: cddListData?.id,
        id: cddListData?.id ? cddListData?.id : "",
        cdd: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        cdd_customer_type: cddListData?.cdd_customer_type
          ? cddCustomerTypeOptions?.find(
              (item) => item.value === cddListData?.cdd_customer_type,
            )?.label
          : "-",

        cdd_type: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        risk: (
          <div className="flex items-center gap-2">
            {cddListData?.risk
              ? riskProfile?.find((item) => item.value == cddListData?.risk)
                  ?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(cddListData?.id, cddListData);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: cddListData?.source ? cddListData?.source : "",

        verification_document_type: "",
        date_verified: cddListData?.verifications[0]?.date_verified
          ? cddListData?.verifications[0]?.date_verified
          : "",
        verified_by: cddListData?.verifications[0]?.verified_by
          ? formatName(
              cddListData?.verifications[0]?.verified_by?.first_name,
              cddListData?.verifications[0]?.verified_by?.last_name,
            )
          : "",
        method: "",
        bureau: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"bureau"}
            fetchData={fetchCDDs}
          />
        ),
        dvs: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"dvs"}
            fetchData={fetchCDDs}
          />
        ),
        pep: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"pep"}
            fetchData={fetchCDDs}
          />
        ),
        sanction: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.beneficiary_id
                ? "beneficiary"
                : cddListData?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : cddListData?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"sanction"}
            fetchData={fetchCDDs}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              cddListData?.summaries[0]?.adverse_media_result
            }
            reference_no={cddListData?.summaries[0]?.request_id}
          />
        ),
        action: (
          <>
            <span className="flex items-center gap-2 justify-center">
              {cddListData?.kyb_report_file ? (
                <KYBReportDownload
                  setLoading={setLoading}
                  kyb_report_file={cddListData?.kyb_report_file}
                />
              ) : (
                <></>
              )}
              {cddListData?.status === 1 ? (
                <Button
                  size={"sm"}
                  className="bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                >
                  <div className="flex items-center gap-1">
                    <CheckCircle2 size={18} />
                    <span>Verified</span>
                  </div>
                </Button>
              ) : cddListData?.status === 2 ? (
                <Button
                  size={"sm"}
                  className="bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                >
                  <div className="flex items-center gap-1">
                    <Clock size={18} />
                    <span>Pending</span>
                  </div>
                </Button>
              ) : (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      <span>/</span>
                    </>
                  )}
                  <CDDVerifyModal
                    loading={loading}
                    listData={cddListData}
                    setCddItem={setCddItem}
                    setCddId={setCddId}
                    cddItem={cddItem}
                    customerType={contactData?.type}
                    setLoading={setLoading}
                    cddId={cddId}
                    sectionType={cddListData?.cdd_customer_type}
                    fecthData={fetchCDDs}
                    defaultMobile={contactData?.mobile}
                    defaultABN={contactData?.abn}
                    cdd={cddListData?.cdd}
                  />
                </>
              )}
            </span>
          </>
        ),
      });
    }
    return items;
  };

  const CDDs = cddsGenerator(cddsList[0]?.verifications?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = user
    ? [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verification_document_type",
          text: "Document Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "date_verified",
          text: "Date Verified",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verified_by",
          text: "Verified By",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "method",
          text: "Method",
        },
        // {
        //   dataField: "source",
        //   text: "Source",
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "biometrics",
          text: "Biometrics",
        },
        {
          dataField: "dvs",
          text: "DVS",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "bureau",
          text: "Bureau",
          headerClasses: THClasses,
          classes: TDClasses,
        },

        {
          dataField: "pep",
          text: "PEP",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "sanction",
          text: "Sanctions",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "adverse_media",
          text: "Adverse Media",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ]
    : [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "cdd_type",
          text: "CDD Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verification_document_type",
          text: "Document Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "date_verified",
          text: "Date Verified",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verified_by",
          text: "Verified By",
        },

        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "method",
          text: "Method",
        },
        {
          dataField: "risk",
          text: "Risk Profile",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        // {
        //   dataField: "source",
        //   text: "Source",
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "biometrics",
          text: "Biometrics",
        },
        {
          dataField: "dvs",
          text: "DVS",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "bureau",
          text: "Bureau",
          headerClasses: THClasses,
          classes: TDClasses,
        },

        {
          dataField: "pep",
          text: "PEP",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "sanction",
          text: "Sanctions",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "adverse_media",
          text: "Adverse Media",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ];

  //* End: Vendor List Columns

  //* End: Vendor List Sorting

  //* End: Vendor List and URL Mangement useEffect

  return (
    <MainBody
      search={false}
      actionContent={<></>}
      loading={loading}
      expandList={true}
      innerBody={true}
      parentHeight={true}
      // mainClassName="w-[calc(100%-3rem)]"
    >
      {/* Vendor Table and Pagination */}
      <div className="custom-table">
        <div className="table-body-class">
          <BootstrapTable
            keyField="id"
            remote
            data={CDDs}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Confirmation
          title={"Verify Data"}
          open={confirmVerify}
          setOpen={setConfirmVerify}
          toggleShow={() => {
            toggleConfirmVerify();
          }}
          className="sm:max-w-1/2"
          message={
            <>
              <div>Are you sure you want to verify the record?</div>
              <div className="grid grid-cols-1 text-left mt-2">
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={cddItem?.method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setMobile(e);
                    }}
                    value={mobile}
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
                <div className="flex items-start space-x-2 mt-4">
                  <Checkbox
                    id="terms"
                    checked={consent}
                    name="same_address"
                    onClick={() => {
                      setConsent(!consent);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                  >
                    I confirm that I am authorised to conduct this identity
                    check and I consent to information being checked with the
                    document issuer or official record holder via third party
                    systems for the purpose of confirming customer identity.
                    Would you like Myna Australia Pty Ltd to verify the id now?
                  </label>
                </div>
              </div>
            </>
          }
          disabled={cddItem?.method === 2 ? !mobile && !consent : !consent}
          okAction={async () => {
            handleVerifyID();
            toggleConfirmVerify();
          }}
          cancelAction={() => {
            toggleConfirmVerify();
          }}
        />

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowVisual}
          >
            <VerifyModal
              data={cddItem}
              toggleVisual={toggleVisual}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {confirmEscalated && (
          <ResponsiveDrawerForm
            description={""}
            title={`Escalated`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleConfirmEscalated();
            }}
            write={true}
            buttonText={""}
            open={confirmEscalated}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setConfirmEscalated}
            className={"sm:max-w-3xl"}
          >
            <EscalatedModal
              data={cddItem}
              toggleConfirmEscalated={toggleConfirmEscalated}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}
      </div>
    </MainBody>
  );
};

export default ExpandContactTypeCDD;
// * End: Vendor Listing Page
